// LEAP
//export const TOKEN_ADDRESS = "0x0666eBbF26CDE07EA79FeCAe15e5f18394EBC149";
// DUC
export const TOKEN_ADDRESS = "0xA6A4fc4E1a80DfeeBFfd4d5c0bb2C704B854b018";
export const PLASMA_PROVIDER = "https://staging-testnet.leapdao.org/rpc";
